import { render, staticRenderFns } from "./v-dynamicTable.vue?vue&type=template&id=74c2e204&scoped=true&"
import script from "./v-dynamicTable.vue?vue&type=script&lang=js&"
export * from "./v-dynamicTable.vue?vue&type=script&lang=js&"
import style0 from "./v-dynamicTable.vue?vue&type=style&index=0&id=74c2e204&prod&lang=scss&"
import style1 from "./v-dynamicTable.vue?vue&type=style&index=1&id=74c2e204&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c2e204",
  null
  
)

export default component.exports